module.exports = __webpack_public_path__ + "zvetseni-prsou_37_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_37_before.jpg
// module id = 1330
// module chunks = 0